import * as Yup from "yup";

export const FORCED_PASSWORD_RULES = {
  MIN_LENGTH: 8,
  MAX_LENGTH: 30,
  UPPERCASE: /[A-Z]/,
  LOWERCASE: /[a-z]/,
  NUMBER: /\d/,
  SYMBOL: /[-!@#$%^&*()_+={}[\]:;"'<>,.?/~]/,
};

export const getForcedPasswordRuleState = (password = "") => ({
  minLength: password.length >= FORCED_PASSWORD_RULES.MIN_LENGTH,
  uppercase: FORCED_PASSWORD_RULES.UPPERCASE.test(password),
  lowercase: FORCED_PASSWORD_RULES.LOWERCASE.test(password),
  number: FORCED_PASSWORD_RULES.NUMBER.test(password),
  symbol: FORCED_PASSWORD_RULES.SYMBOL.test(password),
});

export const hasAllForcedPasswordRules = (password = "") =>
  Object.values(getForcedPasswordRuleState(password)).every(Boolean);

export const createForcedPasswordChangeSchema = (temporaryPassword = "") =>
  Yup.object({
    password: Yup.string()
      .required("Please enter your new password.")
      .max(
        FORCED_PASSWORD_RULES.MAX_LENGTH,
        `Password cannot exceed ${FORCED_PASSWORD_RULES.MAX_LENGTH} characters.`
      )
      .test(
        "password-rules",
        "Password must meet all password requirements.",
        (value = "") => hasAllForcedPasswordRules(value)
      )
      .test(
        "temp-password-match",
        "Your new password can't be the same as your temporary password.",
        (value = "") => {
          if (!temporaryPassword) return true;
          return value !== temporaryPassword;
        }
      ),
    confirmPassword: Yup.string()
      .required("Please confirm your password.")
      .oneOf([Yup.ref("password")], "Passwords don't match. Please try again."),
  });
